export default class IconHelper {
    static getSvgHref(iconId, cssClasses, fill) {
        const style = fill ? ` style="fill:${fill}"` : '';

        if (!cssClasses) {
            cssClasses = '';
        }

        return `<svg class="icon ${iconId} ${cssClasses}"${style}><use xlink:href="#${iconId}" id="#${iconId}"></use></svg>`;
    }
}